<template>
  <div>
     <AppHeader />
     <AppMainMenu />
     <AppNewMenu />
     <AppOurCustomerse />
     <AppFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import AppHeader from "@/components/home/Header";
import AppMainMenu from "@/components/home/OurMenu";
import AppNewMenu from "@/components/home/OurNewMenu";
import AppOurCustomerse from "@/components/home/OurCustomors";
import AppFooter from '@/components/footer/Footer';
import firebase from '@/firebase/index'

export default {
  name: 'Home_page',
  components:{
    AppHeader,
    AppMainMenu,
    AppNewMenu,
    AppOurCustomerse,
    AppFooter
  },
  beforeMount(){
    console.log(firebase.auth().currentuser)
  }
}
</script>
